<template>
    <div>
        <ProductCustomsCodes
            :product="product"
            :title="makeTitle()"
            :categories="product.categories"
            @change="productCategoryChange"
        />
        <ProductCustomsCodes
            v-if="showComponent(component)"
            v-for="component in components"
            :product="component"
            :categories="component.categories"
            :title="component.title"
            :parent-title="component.parentTitle"
            @change="componentCategoryChange"
        />
    </div>
</template>

<script>
import ProductCustomsCodes from "@/views/request/received/flow/components/vertiacal-steps/ProductCustomsCodes";
import {ProductProvider} from "@core/domain/product";

export default {
    components: {ProductCustomsCodes},
    props: {
        product: {
            required: true,
        },
        components: {
            required: true
        }
    },
    methods: {
        showComponent(component) {
            if (this.product.id === component.id) {
                return false;
            }

            if (component.hasOwnProperty('scipInformation') && component.scipInformation.id) {
                return false;
            }

            return true;
        },
        makeTitle() {
            return this.product.names.length > 0 ? this.product.names[0].value : '';
        },
        productCategoryChange(categories, product, showOverlay, hideOverlay) {
            const productDomain = ProductProvider(product.id);
            this
                .saveCategories(productDomain, categories, showOverlay, hideOverlay)
                .then(() => {
                    this.product.categories = categories;
                    this.emitValidity();
                })
            ;
        },
        componentCategoryChange(categories, component, showOverlay, hideOverlay) {
            component.categories = categories;
            const product = ProductProvider(component.id);
            this
                .saveCategories(product, categories, showOverlay, hideOverlay)
                .then(() => this.emitValidity())
            ;
        },

        saveCategories(productDomain, categories, showOverlay, hideOverlay) {
            showOverlay();
            return productDomain
                .getCard()
                .then((card) => {
                    productDomain.setCategories(categories);
                    return productDomain.saveCard();
                })
                .then(() => {
                    hideOverlay();
                })
            ;
        },

        emitValidity() {
            let valid = true;

            if (this.product.categories.length === 0) {
                valid = false;
            } else {
                if (this.components.length > 0) {
                    this.components.forEach(component => {
                        if (!this.showComponent(component)) {
                            return;
                        }
                        if (component.categories.length === 0) {
                            valid = false;
                        }
                    })
                }
            }

            this.$emit('validityChanged', valid)
        },
    },

    watch: {
        components() {
            this.emitValidity();
        }
    }
}
</script>

